import React, { useState } from 'react';

import { ChangePasswordStep } from '@/modules/user/components/ManageProfile/components/Security/security.types';

import ChangePasswordSuccessModal from './ChangePasswordSuccessModal';
import EnterNewPasswordModal from './EnterNewPasswordModal';

interface Props {
  onSetVisible: (value: boolean) => void;
}

const EmailVerificationModal: React.FC<Props> = ({ onSetVisible }) => {
  const [step, setStep] = useState(ChangePasswordStep.ENTER_NEW_PASSWORD);

  return (
    <>
      {step === ChangePasswordStep.ENTER_NEW_PASSWORD && (
        <EnterNewPasswordModal onSetVisible={onSetVisible} setStep={setStep} />
      )}
      {step === ChangePasswordStep.SUCCESSFULLY_CHANGED && (
        <ChangePasswordSuccessModal onSetVisible={onSetVisible} />
      )}
    </>
  );
};

export default EmailVerificationModal;
